import { axiosInstance } from "..";

const interiorDesignCategoriesList = async (querry) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`internal/Interiordesign/categories?${querry}`)
      .then((res) => {
        if (res.status === 200) {
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default interiorDesignCategoriesList;
